<template>
  <div
    :key="video.id"
    class="bg-dark-darkest"
  >
    <video-youtube
      v-if="isFromYoutube"
      :autoplay="autoplay"
      :video="video"
      @ended="ended"
    />
    <video-dailymotion
      v-else-if="isFromDailymotion"
      :video="video"
      :autoplay="autoplay"
    />
    <video-vimeo
      v-else-if="isFromVimeo"
      :video="video"
      :autoplay="autoplay"
    />
  </div>
</template>

<script>

import { Event, Type } from '@/src/server/helpers/constants'
import VideoYoutube from './VideoYoutube'
import VideoDailymotion from './VideoDailymotion'
import VideoVimeo from './VideoVimeo'

const TYPE_YOUTUBE = 'youtube'
const TYPE_DAILYMOTION = 'dailymotion'
const TYPE_VIMEO = 'vimeo'

export default {
  components: {
    VideoDailymotion,
    VideoYoutube,
    VideoVimeo,
  },
  props: {
    video: {
      type: Object,
      default () {
        return {}
      },
      validator (value) {
        return !value.id || (value.type === Type.VIDEO && value.attributes && value.attributes.url)
      },
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    videoType () {
      if (this.video && this.video.attributes) {
        const url = this.video.attributes.url

        if (url.match(/(youtu.be|youtube)/)) {
          return TYPE_YOUTUBE
        }

        if (url.match(/(dailymotion\.com|dai\.ly)/)) {
          return TYPE_DAILYMOTION
        }

        if (url.match(/vimeo/)) {
          return TYPE_VIMEO
        }
      }
    },
    isFromYoutube () {
      return this.videoType === TYPE_YOUTUBE
    },
    isFromDailymotion () {
      return this.videoType === TYPE_DAILYMOTION
    },
    isFromVimeo () {
      return this.videoType === TYPE_VIMEO
    },
  },
  methods: {
    ended (payload) {
      this.$emit(Event.ENDED, payload)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/server/components/Videos/Video.vue